import { Service } from '@roc/feature-app-core';

const url = {
  EXPECTED_CLOSING_DATE:
    '/api/v1/document/formDocument/updateExpectedClosingDate',
  GET_LOAN_CLOSING_ADJOURNMENT_DATA:
    '/api/v1/loan/getLoanClosingAdjournmentData',
  SAVE_LOAN_CLOSING_ADJOURNMENT_DATA:
    '/api/v1/loan/saveLoanClosingAdjournmentData'
};

export class ExpectedClosingDateService extends Service {
  submitExpectedClosingDate(loanId: string, expectedClosingDate: string) {
    return this.put(
      url.EXPECTED_CLOSING_DATE +
      '?loanID=' +
      loanId +
      (expectedClosingDate
        ? `&expectedClosingDate=${expectedClosingDate}`
        : ``),
      {}
    );
  }

  getLoanClosingAdjournmentData(loanId: string) {
    return this.get(`${url.GET_LOAN_CLOSING_ADJOURNMENT_DATA}?loanId=${loanId}`);
  }

  saveLoanClosingAdjournmentData(data: any) {
    return this.post(
      url.SAVE_LOAN_CLOSING_ADJOURNMENT_DATA,
      data
    );
  }
}
